export type BaseAppConfig = {
  environment: string;
  redirect: string;
  clientUrl: string;
  hostname: string;
  defaultRoute: string;
  baseApi: string;
  theme: "dark-mode" | "light-mode";
  showContents: boolean;
  allowThemeChange: boolean;
  allowNewWorkspace: boolean;
  wsPolicyStudioUrl: string;
  personalMode: boolean;
  slackTestingMode: boolean;
  showReportCard: boolean;
  showGoogleDrive: boolean;
  showWebsiteIngest: boolean;
  showPersonas: boolean;
  showUrlMultiInput: boolean;
  showPolicyStudio: boolean;
  killPolicyStudio: boolean;
  wsAiUrl: string;
  wsAgentUrl: string;
  enforceHrisIntegration: boolean;
  showLinkRecordLogs: boolean;
  showDebugChat: boolean;
};

export default function buildConfig(baseApi: string): BaseAppConfig {
  return {
    environment: "development",
    redirect: "http://localhost:3000/signup",
    clientUrl: "http://localhost:3000",
    hostname: "localhost",
    wsPolicyStudioUrl: "ws://localhost:8081/ws/ps/policy-studio",
    wsAiUrl: "ws://localhost:8081/ws/ai/ask",
    defaultRoute: "/home",
    baseApi,
    showBaton: true,
    showStatuses: true,
    theme: "light-mode",
    showContents: true,
    allowThemeChange: false,
    allowNewWorkspace: true,
    personalMode: true,
    slackTestingMode: true,
    showReportCard: true,
    showGoogleDrive: true,
    showWebsiteIngest: true,
    showPersonas: true,
    showUrlMultiInput: true,
    showPolicyStudio: true,
    killPolicyStudio: false,
    wsAgentUrl: "ws://localhost:8081/ws/agent/ask",
    enforceHrisIntegration: false,
    showLinkRecordLogs: true,
    showDebugChat: false,
  } as BaseAppConfig;
}

export const loadEnvConfig = (key: string) => {
  const value = process.env[key];
  if (!value || value === "") {
    throw new Error(`Missing environment variable: ${key}`);
  }
  return value;
};
